require("../vendor/tarteaucitron/tarteaucitron.js");
require("../vendor/tarteaucitron/lang/tarteaucitron.fr.js");
require("../vendor/tarteaucitron/tarteaucitron.services.js");

const initTarteAuCitron = () => {
  if (!window.tarteaucitron) return;
  tarteaucitron.init({
    "hashtag": "#tarteaucitron",
    "cookieName": "tarteaucitron",
    "removeCredit": true,
    privacyUrl: "/politique_de_confidentialite",
    orientation: "middle",
    showAlertSmall: false,
    cookieslist: true,
    adblocker: false,
    highPrivacy: true,
    "handleBrowserDNTRequest": false,
    "useExternalCss": true,
    "moreInfoLink": true,
    "readmoreLink": "politique_de_confidentialite",
    lang: "fr",
    "mandatory": true
  });
};

export { initTarteAuCitron };
